import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import BlogIndex from "./BlogIndex";
import { getPages } from "../../Utility/nevtanPagesApi";

// Route wrapper for /blog — fetches the published articles client-side
// (replaces Next's getServerSideProps) and renders the listing UI.
const BlogListing = () => {
  const { i18n } = useTranslation();
  const [pages, setPages] = useState([]);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await getPages(i18n.language);
        if (active && res?.success && Array.isArray(res.data)) {
          setPages(res.data);
        }
      } catch (e) {
        // degrade to an empty list — the page still renders "No articles yet."
      }
    })();
    return () => {
      active = false;
    };
  }, [i18n.language]);

  return <BlogIndex pages={pages} />;
};

export default BlogListing;
